import { render, staticRenderFns } from "./CorrespondenceEmailPreview.vue?vue&type=template&id=4a8e8e9e&scoped=true"
import script from "./CorrespondenceEmailPreview.vue?vue&type=script&lang=js"
export * from "./CorrespondenceEmailPreview.vue?vue&type=script&lang=js"
import style0 from "./CorrespondenceEmailPreview.vue?vue&type=style&index=0&id=4a8e8e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e8e9e",
  null
  
)

export default component.exports